const PageRoutes = {
  //---AUTH---
  authHomePage: "giris",
  loginWorker: "/personel-giris",
  loginFirm: "/firma-giris",
  signupWorker: "/personel-kayıt",
  signupFirm: "/firma-kayıt",
  forgotPasswordFirm: "/sifremi-unuttum-firma",
  forgotPasswordWorker: "/sifremi-unuttum-personel",

  //---Common---
  home: "/",
  sözlesme: "/sözlesmeler",
  dataDelete: "/veri-silme-politikasi",

  //---PROFILE---

  //---FORM PAGE---
  firmHome: "/firmHome",

  //---FIRM PAGES---
  firmInfo: "/firm-info",
  firmUsers: "/firmUsers",
  updateFirmUser: "/updateFirmUser",
  addFirmUser: "/addFirmUser",
  advertDetailFirm: "/firma-ilan-detay",
  firmDocuments: "/firma-belgeler",

  //---FIRM ADVERT PAGES---
  createAdvert: "/ilan-olustur",
  adverts: "/firma-ilanlar",
  activeJobs: "/activeJobs",
  draftJobs: "/draftJobs",
  editAdvert: "/ilan-duzenle",
  copyAdvert: "/ilan-kopyala",

  //---FIRM DOCUMENT PAGES---
  documentUploadFirm: "/firma-belge-yukle",

  // firmImage: "firma-profil-düzenle",

  //---EMPLOYEE PAGES---
  advertDetailEmployee: "/ilan-detay",
  detailedProfile: "/profil-detay",
  personnelHome: "/personel-anasayfa",
  personnelSettings: "/personel-ayarlar",
  listings: "/ilanlar",
  favoriteAdverts: "/ilan-favoriler",
  appliedAdverts: "/ilan-basvurulmus",
  recommendedAdverts: "/ilan-onerilen",
  assignedAdverts: "/ilan-onaylanmis",
  documentManagement: "/belge-yonetimi",
  documentUpload: "/belge-yukle",

  //DEFAULT
  missing: "/*",
  unauthorized: "/unauthorized",
  error: "/error",
  success: "/success",
};

export default PageRoutes;
